import React, { useState, useEffect, useMemo } from 'react';
import './ContenedorMaterias.css';
import BotonMateria from './BotonMateria';
import imagen_materia from '../Assets/materia.jpg';
import loader_img from '../Assets/spin.svg';
import axios from 'axios';
import { getClasesStudent } from '../Pages/constants';
import { useData } from '../Pages/DataContext';
import { SORT_CRITERIA, SORT_OPTIONS, sortCourses } from './sortUtils';

const ContenedorMateriasAlumno = ({ redireccionB }) => {
  const [materias, setMaterias] = useState([]);
  const { setClaseData } = useData();
  const { data } = useData();
  const [showing, setShowing] = useState(true);
  const [sortCriterion, setSortCriterion] = useState(SORT_CRITERIA.RECENT);

  // Paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const materiasPorPagina = 9;

  useEffect(() => {
    setTimeout(() => {
      setShowing(false);
      fetchMaterias();
    }, 3000);
  }, []);

  const fetchMaterias = async () => {
    try {
      const response = await axios.get(`${getClasesStudent}?matricula_alumno=${data.matricula}`);
      console.log("!!Contenedor Materias Alumno " + response.data.length);
      console.log("Response Status " + response.status);

      if (response.data.length > 0) {
        response.data.forEach(element => {
          console.log("Nombre de Clase " + element.nombre_clase);
        });

        setMaterias(response.data);
      } else {
        console.log("Entrando al error Materias Alumno");
        alert("Error al obtener las materias, intentalo nuevamente");
      }
    } catch (error) {
      alert("ERR_CMA: Error al obtener las materias, intentalo nuevamente");
      console.error('Error al obtener las materias:', error);
    }
  };

  const editarClase = (val) => {
    setClaseData(val);
    console.log("Valores de clase: ", val);
  };

  const orderedMaterias = useMemo(
    () => sortCourses(materias, sortCriterion),
    [materias, sortCriterion],
  );

  useEffect(() => {
    setPaginaActual(1);
  }, [sortCriterion]);

  // Calcular total de páginas
  const totalPaginas = Math.ceil(orderedMaterias.length / materiasPorPagina);

  // Calcular las materias de la página actual después de ordenar
  const indiceUltimaMateria = paginaActual * materiasPorPagina;
  const indicePrimeraMateria = indiceUltimaMateria - materiasPorPagina;
  const materiasActuales = orderedMaterias.slice(indicePrimeraMateria, indiceUltimaMateria);

  return (
    <div className="contenedor-materias">
      {showing ? (
        <img src={loader_img} className="center" alt="Cargando..." />
      ) : (
        <>
          <div className="materias-toolbar materias-toolbar-single">
            <label className="ordenamiento-control">
              <span className="materias-control-label">Ordenar por</span>
              <select
                value={sortCriterion}
                onChange={(event) => setSortCriterion(event.target.value)}
              >
                {SORT_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </label>
          </div>

          {materiasActuales.map((materia, index) => (
            <BotonMateria
              key={materia.id_clase || materia.matricula_clase}
              imagen={imagen_materia}
              nombre={(index + 1 + indicePrimeraMateria) + " " + (materia.nombre_clase || "")}
              descripcion={materia.descripcion}
              salon={materia.matricula_clase}
              profesor={materia.matricula_maestro}
              redireccion={redireccionB}
              onEditarClase={() => editarClase(materia)}
            />
          ))}

          {totalPaginas > 1 && (
            <div className="paginacion">
              <button
                onClick={() => setPaginaActual(paginaActual - 1)}
                disabled={paginaActual === 1}
              >
                Anterior
              </button>

              <span className="pagina-info">
                Página {paginaActual} de {totalPaginas}
              </span>

              <button
                onClick={() => setPaginaActual(paginaActual + 1)}
                disabled={paginaActual === totalPaginas}
              >
                Siguiente
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContenedorMateriasAlumno;
